import React, { useMemo, useState, useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import Layout from "Layout";
import AuthProtected from "./AuthProtected";
import Routepage from "./allRoutes";

const RouteIndex = () => {
  const [tokenVersion, setTokenVersion] = useState(0);

  useEffect(() => {
    const updateRoutes = () => {
      setTokenVersion((v) => v + 1);
    };

    window.addEventListener("storage", updateRoutes);
    window.addEventListener("auth-change", updateRoutes);

    return () => {
      window.removeEventListener("storage", updateRoutes);
      window.removeEventListener("auth-change", updateRoutes);
    };
  }, []);

  const [protectedRoutes, publicRoutes] = useMemo(
    () => Routepage(),
    [tokenVersion]
  );

  return (
    <Routes>
      {protectedRoutes.map((route: any, idx: number) => {
        const Component = route.component;

        return (
          <Route
            key={`protected-${idx}`}
            path={route.path}
            element={
              <AuthProtected>
                <Layout>
                  <Component />
                </Layout>
              </AuthProtected>
            }
          />
        );
      })}

      {publicRoutes.map((route: any, idx: number) => {
        const Component = route.component;

        return (
          <Route
            key={`public-${idx}`}
            path={route.path}
            element={<Component />}
          />
        );
      })}
    </Routes>
  );
};

export default RouteIndex;